import { PieChart } from '@mui/x-charts/PieChart'
import { Paper, Typography, CircularProgress, Box, Card, CardContent, Grid } from '@mui/material'
import { useGetTransactionHistoryDashboardQuery } from 'store/dashboard'
import HorizontalLineChart from 'components/chart/HorizontalLineChart'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import { lineChartSlotProps, chartSx } from './chartDefaults'

const TransactionHistoryChart = () => {
  const { startDate, endDate } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetTransactionHistoryDashboardQuery({
    startDate,
    endDate
  })

  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (data.statusSummary ?? []).length === 0 && (data.memberTierSummary ?? []).length === 0 ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <>
          <Grid container spacing={2} mb={4} alignItems='center'>
            <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
              <ChartTitle tooltip="Percentage of Genuine Accessories transaction">Genuine Accessories</ChartTitle>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', overflow: 'auto' }}>
                <PieChart
                  series={[
                    {
                      innerRadius: 60,
                      outerRadius: 100,
                      cx: 120,
                      data: data.statusSummary.map((item, idx) => ({
                        id: idx,
                        value: item.count,
                        label: `${item.status} (${item.percentage.toFixed(1)}%)`
                      }))
                    }
                  ]}
                  width={500}
                  height={300}
                  sx={{ flexShrink: 0, ...chartSx }}
                  margin={{ top: 10, bottom: 10, left: 10, right: 150 }}
                  slotProps={lineChartSlotProps}
                />
              </Box>
              <Box
                sx={{ alignSelf: 'flex-start', bgcolor: '#E8F5E9', borderRadius: 1, p: 1, mt: 2 }}
              >
                <Typography variant='body1' sx={{ fontWeight: 'bold', color: '#4CAF50' }}>
                  Conversion Rate: {(data.conversionRate ?? 0).toFixed(1)}%
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Card sx={{ bgcolor: '#f5f5f5', border: 'none', boxShadow: 'none' }}>
                <CardContent sx={{ textAlign: 'center', p: 2 }}>
                  <Typography variant='caption' color='textSecondary' sx={{ mb: 0.5, display: 'block', fontSize: '0.7rem' }}>
                    Total Revenue Genuine Accessories
                  </Typography>
                  <Typography variant='body1' sx={{ fontWeight: 'bold', color: '#4CAF50', fontSize: '1rem' }}>
                    IDR {(data.totalRevenue ?? 0).toLocaleString('id-ID')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container mb={4}>
            <Grid item xs={12}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Transaction by Member Tier
              </Typography>
              <HorizontalLineChart
                data={data.memberTierSummary.map((item) => ({
                  label: item.tier,
                  value: item.count,
                  color: item.color
                }))}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Paper>
  )
}

export default TransactionHistoryChart
